import _set from 'lodash-es/set'

export const extendGlobal = (methodName: string, value: any): void => {
  if (!window.$flomni) {
    window.$flomni = {}
  }

  if (!window.Flomni_API) {
    window.Flomni_API = {}
  }

  _set(window.$flomni, methodName, value)
  _set(window.Flomni_API, methodName, value)
}
